import React from 'react'
import gifDesktop from '../assets/img/gif/pokefarm_exemple_desktop.gif'
import gifPhone from '../assets/img/gif/pokefarm_exemple_phone.gif'
import './CommentJouer.css'

function CommentJouer() {
  return (
    <section id="comment-jouer" className="comment-jouer" aria-labelledby="comment-jouer-title">
      <header>
        <h2 id="comment-jouer-title" className="section-title">Comment jouer</h2>
        <p className="section-subtitle">
          Explore les régions, choisis une zone et attrape des Pokémon
        </p>
      </header>

      <div className="comment-jouer-content">
        <div className="comment-jouer-visual">
          <picture>
            <source
              media="(max-width: 768px)"
              srcSet={gifPhone}
            />
            <source
              media="(min-width: 769px)"
              srcSet={gifDesktop}
            />
            <img
              src={gifDesktop}
              alt="Exemple d'utilisation Pokéfarm : navigation dans les régions et zones pour capturer des Pokémon"
              className="comment-jouer-img"
            />
          </picture>
        </div>
        <div className="comment-jouer-text">
          <p>
            Une fois le bot installé, une catégorie <strong>Pokéfarm</strong> apparaît en bas de ton serveur.
            À l'intérieur, les <strong>régions</strong> (Kanto, Johto, Hoenn, Sinnoh) sont des forums,
            et chaque <strong>zone</strong> (Bourg Palette, Route Victoire, etc.) est un post.
          </p>
          <p>
            Chaque zone propose des pokémon différents, fait le tour des régions pour compléter tes Pokédex (ou Shinydex),
            faire évoluer tes Pokémon et tenter ta chance aux Shiny !
          </p>
        </div>
      </div>
    </section>
  )
}

export default CommentJouer
